var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path, _rect0, _rect1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicroreelSource(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 63.684,
    y: 42.029,
    width: 159.012,
    height: 118.966,
    rx: 15,
    transform: "rotate(4.114 63.684 42.029)",
    stroke: "#2B8982",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 87.448,
    y: 90.218,
    width: 83.491,
    height: 2.56,
    rx: 1.28,
    transform: "rotate(4.114 87.448 90.218)",
    fill: "#2B8982"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 86.621,
    y: 101.708,
    width: 97.122,
    height: 2.56,
    rx: 1.28,
    transform: "rotate(4.114 86.621 101.708)",
    fill: "#2B8982"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 89.625,
    y: 113.474,
    width: 83.491,
    height: 2.56,
    rx: 1.28,
    transform: "rotate(4.114 89.625 113.474)",
    fill: "#2B8982"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 73.055,
    y: 58.383,
    width: 26.88,
    height: 2.56,
    rx: 1.28,
    transform: "rotate(4.114 73.055 58.383)",
    fill: "#2B8982"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 182.852,
    y: 66.28,
    width: 26.88,
    height: 2.56,
    rx: 1.28,
    transform: "rotate(4.114 182.852 66.28)",
    fill: "#2B8982"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 176.699,
    y: 151.819,
    width: 26.88,
    height: 2.56,
    rx: 1.28,
    transform: "rotate(4.114 176.699 151.819)",
    fill: "#2B8982"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 70.011,
    y: 106.386,
    width: 28.966,
    height: 2.56,
    rx: 1.28,
    transform: "rotate(4.114 70.01 106.386)",
    fill: "#2B8982"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 34.276,
    y: 78.857,
    width: 97.927,
    height: 153.35,
    rx: 16,
    transform: "rotate(-10.488 34.276 78.857)",
    fill: "#2B8982"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M89.994 131.653a2.78 2.78 0 00-2.814.662c-.745.704-1.084 1.824-.889 2.938l2.83 15.289c.218 1.11.935 2.033 1.883 2.425a2.78 2.78 0 002.864-.39l11.301-9.097c1.164-.879 1.725-2.48 1.429-4.08-.296-1.6-1.393-2.894-2.795-3.298l-13.809-4.449z",
    stroke: "#F6F7F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 67.235,
    y: 206.383,
    width: 28.966,
    height: 2.56,
    rx: 1.28,
    transform: "rotate(-10.488 67.235 206.383)",
    fill: "#F6F7F9"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 68.352,
    y: 214.312,
    width: 56.098,
    height: 2.56,
    rx: 1.28,
    transform: "rotate(-10.488 68.352 214.312)",
    fill: "#F6F7F9"
  })));
}
export default SvgMicroreelSource;